// extracted by mini-css-extract-plugin
export default {"title":"LKPage_title__65QLR"};